<template>
    <div>
        <el-dialog :title="$t('activityDetails')"
                   :visible.sync="dialogVisible"
                   :close-on-click-modal="false"
                   @close="dialogClose"
                   center
                   top="5vh"
                   custom-class="large-dialog">
            <div class="content">
                <el-form :model="formData"
                         size="mini"
                         label-width="110px">
                    <div class="form-two">
                        <el-form-item :label="$t('activityName')">
                            <el-input v-model="formData.name"
                                      autocomplete="off" readonly></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('activityTime')">
                            <el-date-picker
                                v-model="formData.date"
                                type="datetimerange"
                                format="yyyy-MM-dd HH:mm:ss"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                range-separator="-"
                                :start-placeholder="$t('startTime')"
                                :end-placeholder="$t('endTime')"
                                :clearable="false"
                                time-arrow-control
                                readonly>
                            </el-date-picker>
                        </el-form-item>
                    </div>
                    <div class="form-multi">
                        <el-form-item :label="$t('lotteryTime')">
                            <el-date-picker
                                v-model="formData.luckyDrawAt"
                                type="datetime"
                                format="yyyy-MM-dd HH:mm:ss"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                :clearable="false"
                                time-arrow-control
                                readonly>
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item :label="$t('lotteryDuration')"
                                      prop="durationTime">
                            <el-input
                                type="number"
                                v-model="formData.durationTime"
                                autocomplete="off" readonly>
                                <template slot="append">h</template>
                            </el-input>
                        </el-form-item>
                        <el-form-item :label="$t('whetherEnable')"
                                      prop="enabled">
                            <el-switch
                                v-model="formData.enabled"
                                active-color="#13ce66"
                                inactive-color="#dcdfe6" disabled>
                            </el-switch>
                        </el-form-item>
                    </div>
                    <el-form-item :label="$t('remark')"
                                  prop="remark">
                        <el-input
                            type="textarea"
                            v-model="formData.remark"
                            autocomplete="off" readonly></el-input>
                    </el-form-item>
                </el-form>
                <div class="awards">
                    <div class="awards-header">
                        <span class="label">{{ $t('awards') }}</span>
                        <el-button type="primary" size="mini" @click="addDialog = true">{{ $t('add') }}</el-button>
                    </div>
                    <el-table
                        :data="awardsList"
                        border
                        style="width: 100%">
                        <el-table-column type="index" align="center" width="60"></el-table-column>
                        <el-table-column prop="name" :label="$t('awardsName')" align="center" min-width="150" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="awardName" :label="$t('prizeName')" align="center" min-width="150" show-overflow-tooltip></el-table-column>
                        <el-table-column :label="$t('invalidTime')" align="center" width="180">
                            <template slot-scope="scope">
                                <span>{{ scope.row.awardInvalidAt | formatDate('yyyy-mm-dd') }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="code" :label="$t('winningCode')" align="center" width="120" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="shopName" :label="$t('shop')" align="center" width="150" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="sort" :label="$t('sortValue')" align="center" width="120" show-overflow-tooltip></el-table-column>
                        <el-table-column
                            class-name="handle"
                            :label="$t('handle')"
                            align="center"
                            fixed="right"
                            width="80">
                            <template slot-scope="scope">
                                <el-button
                                    class="red"
                                    type="text"
                                    @click="deleteHandle(scope.row.id)">{{$t('delete')}}</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
            <div slot="footer"
                 class="dialog-footer">
                <el-button size="mini" @click="dialogVisible = false">{{ $t('close') }}</el-button>
            </div>
        </el-dialog>
        <!-- 添加奖项 -->
        <AddAwards
            :parent-dialog="addDialog"
            @parent-update="getDetails"
            @parent-close="addDialog = false"/>
    </div>
</template>

<script>
import {
    deleteLotteryAwardsQuota, queryLotteryActivityDetails
} from "@/api/modules/api";
import AddAwards from '@/components/lottery/awards/Add'
export default {
    name: 'Details',
    props: {
        parentDialog: {
            type: Boolean,
            default: true
        },
        parentId: {
            type: String,
            default: ''
        },
    },
    components: {
        AddAwards
    },
    data () {
        return {
            dialogVisible: false,
            formData: {
                name: '',
                date: [],
                luckyDrawAt: '',
                durationTime: '',
                enabled: true,
                remark: ''
            },
            awardsList: [],
            addDialog: false
        }
    },
    created () { },
    mounted () { },
    watch: {
        parentDialog (val) {
            if (val) {
                this.initData()
            }
        },
    },
    methods: {
        // 初始化数据
        initData () {
            this.dialogVisible = true
            // 获取详情
            this.getDetails()
        },
    
        // 获取详情
        getDetails () {
            queryLotteryActivityDetails(this.parentId).then((res) => {
                if (Number(res.code) === 20000) {
                    let resData = res.data
                    // 活动时间
                    let date = []
                    let startedAt = this.$moment(resData.startedAt).format('YYYY-MM-DD HH:mm:ss')
                    let endedAt = this.$moment(resData.endedAt).format('YYYY-MM-DD HH:mm:ss')
                    if (startedAt && endedAt) {
                        date[0] = startedAt
                        date[1] = endedAt
                    }
                    // 抽奖时间
                    let luckyDrawAt = this.$moment(resData.luckyDrawAt).format('YYYY-MM-DD HH:mm:ss')
                    this.formData = {
                        name: resData.name,
                        date,
                        luckyDrawAt,
                        durationTime: resData.durationTime,
                        enabled: resData.enabled,
                        remark: resData.remark
                    }
                    // 活动项
                    let awardsList = []
                    let activityAwards = resData.activityAwards || []
                    activityAwards.forEach(item => {
                        let winAwardCodes = item.winAwardCodes || []
                        winAwardCodes.forEach(inItem => {
                            awardsList.push(
                                {
                                    id: inItem.id,
                                    name: item.name,
                                    awardName: item.awardDepot.name,
                                    awardInvalidAt: item.awardInvalidAt,
                                    code: inItem.code,
                                    shopName: inItem.shopName,
                                    sort: item.sort
                                }
                            )
                        })
                    })
                    this.awardsList = awardsList
                } else {
                    this.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error'
                    })
                }
            }).catch((err) => {
                this.$message.error(err);
            });
        },
    
        // 删除
        deleteHandle (id) {
            this.$confirm(this.$t('deleteItemHint'), this.$t('hint'), {
                confirmButtonText: this.$t('confirm'),
                cancelButtonText: this.$t('cancel'),
                type: 'warning'
            }).then(() => {
                deleteLotteryAwardsQuota(id).then(res => {
                    if (Number(res.code) === 20000) {
                        this.$message({
                            showClose: true,
                            message: res.msg,
                            type: 'success'
                        })
                        // 获取详情
                        this.getDetails()
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.msg,
                            type: 'error'
                        })
                    }
                }).catch(err => {
                    this.$message.error(err)
                })
            }).catch(() => {})
        },
        
        // 关闭弹窗
        dialogClose () {
            // 重置表单
            this.$emit('parent-close')
        }
    },
}
</script>

<style scoped lang="scss">
@import '../../../assets/css/form-dialog.scss';
.awards{
    margin-top: 20px;
    .awards-header{
        padding-bottom: 10px;
        .label{
            margin-left: 10px;
            margin-right: 20px;
        }
    }
}
</style>
